<template>
  <UiNavbarTop />
  <main data-testid="checkout-layout">
    <NarrowContainer>
      <div>
        <span class="!flex justify-center my-40 h-24" v-if="isLoading && !cart">
          <SfLoaderCircular size="3xl" />
        </span>
        <slot v-else />
      </div>
    </NarrowContainer>
  </main>
<!--  <UiFooter />-->
</template>

<script setup lang="ts">
import { SfButton, SfIconArrowBack, SfLoaderCircular } from '@storefront-ui/vue';

defineProps<{
  backLabelDesktop: string;
  backLabelMobile: string;
  backHref: string;
  heading: string;
}>();

const { fetchCart, data: cart, loading: isLoading } = useCart();

fetchCart();

const NuxtLink = resolveComponent('NuxtLink');
</script>
